/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MessageModel } from "./MessageModel";
export const MessageCollection = core.serialization.object({
    data: core.serialization.list(MessageModel),
});
